import React, { Component } from 'react';
import { compose } from 'redux';
import { toast } from 'react-toastify';
import { Redirect } from 'react-router-dom';

import withSqlReports from 'decorators/withSqlReports';
import Pagination from 'components/Pagination/Pagination';
import Spinner from 'components/Spinner';
import SqlReportsTable from 'components/SqlReportsTable';
import { handleSqlReportError } from 'helpers/errors';
import { downloadSqlReport, exportSqlReport, runSqlReport } from 'api';

class ViewSqlReports extends Component {
  state = {
    localLoading: false,
  };

  getNextPage = (nextPage) => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    return `/reporting/automated-reports?page=${nextPage}`;
  };

  handleDownload = async (id) => {
    try {
      this.setState({ localLoading: true });
      const response = await downloadSqlReport(id);
      const href = URL.createObjectURL(response.data);
      // create "a" HTML element with href to file & click
      const link = document.createElement('a');
      link.href = href;
      document.body.appendChild(link);
      link.click();
      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
      toast.success('Report downloaded');
    } catch (e) {
      toast.error(handleSqlReportError(e));
    } finally {
      this.setState({ localLoading: false });
    }
  };

  handleRun = async (id) => {
    try {
      this.setState({ localLoading: true });
      await runSqlReport(id);
      toast.success('Report is running');
    } catch (e) {
      toast.error(handleSqlReportError(e));
    } finally {
      this.setState({ localLoading: false });
    }
  };

  handleGSheet = async (id) => {
    try {
      this.setState({ localLoading: true });
      const response = await exportSqlReport(id);
      toast.success(
        () => (
          <div>
            <a
              href={response.data.report_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              View Google Sheet
            </a>
          </div>
        ),
        { autoClose: false },
      );
    } catch (e) {
      toast.error(handleSqlReportError(e));
    } finally {
      this.setState({ localLoading: false });
    }
  };

  render() {
    const {
      sqlReports,
      pageCount,
      loading,
      page,
      loggedInUser,
      isAdminOrManager,
    } = this.props;
    const { localLoading } = this.state;

    if (loggedInUser && !isAdminOrManager) {
      return <Redirect to="/" />;
    }

    return (
      <div>
        <h1>Automated Reports</h1>
        <SqlReportsTable
          sqlReports={sqlReports}
          handleDownload={this.handleDownload}
          handleRun={this.handleRun}
          handleGSheet={this.handleGSheet}
        />
        <Pagination count={pageCount} current={page} url={this.getNextPage} />
        <Spinner showLoader={loading || localLoading} />
      </div>
    );
  }
}

export default compose(withSqlReports)(ViewSqlReports);
